var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("crear-actualizar-inamovilidad"),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [
            _vm._v("accessibility")
          ]),
          _vm._v("Inamovilidad\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c("ver-documento"),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "crud-table",
                {
                  attrs: {
                    headers: _vm.headers,
                    url: _vm.url,
                    filters: _vm.filters,
                    "data-graphql": _vm.dataGraphql,
                    graphql: _vm.graphql,
                    initData: _vm.initData
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(items) {
                        return [
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  items.item.parametro_causal
                                    ? items.item.parametro_causal.valor
                                    : ""
                                ) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm
                                    .$moment(items.item.fecha_inicio)
                                    .format("DD/MM/YYYY")
                                ) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm
                                    .$moment(items.item.fecha_fin)
                                    .format("DD/MM/YYYY")
                                ) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-center" },
                            [
                              _vm.estado == 1 || _vm.rol != 42
                                ? _c(
                                    "v-tooltip",
                                    { attrs: { bottom: "" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            slot: "activator",
                                            color: "primary",
                                            icon: ""
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.crearActualizarInamovilidad(
                                                items.item
                                              )
                                            }
                                          },
                                          slot: "activator"
                                        },
                                        [_c("v-icon", [_vm._v("edit")])],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Editar registro")])
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-tooltip",
                                { attrs: { bottom: "" } },
                                [
                                  items.item.url_documento.length > 0
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            slot: "activator",
                                            color: "green",
                                            dark: "",
                                            icon: ""
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.verDocumento(
                                                items.item
                                              )
                                            }
                                          },
                                          slot: "activator"
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "dark" } },
                                            [_vm._v("visibility")]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Ver registro")])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.estado == 1
                                ? _c(
                                    "v-tooltip",
                                    { attrs: { bottom: "" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            slot: "activator",
                                            color: "red",
                                            dark: "",
                                            icon: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.deleteItem(
                                                items.item.id,
                                                "inamovilidad"
                                              )
                                            }
                                          },
                                          slot: "activator"
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "dark" } },
                                            [_vm._v("delete")]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Eliminar registro")])
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c(
                    "template",
                    { slot: "buttons" },
                    [
                      _c(
                        "v-tooltip",
                        { attrs: { bottom: "" } },
                        [
                          _vm.estado == 1
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    slot: "activator",
                                    color: "primary",
                                    dark: ""
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.crearActualizarInamovilidad({})
                                    }
                                  },
                                  slot: "activator"
                                },
                                [
                                  _c("v-icon", { attrs: { dark: "" } }, [
                                    _vm._v("add")
                                  ]),
                                  _vm._v(" " + _vm._s(_vm.$t("common.add")))
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", [_vm._v("Agregar Inamovilidad")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2dbd8a59", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dbd8a59","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/ficha_personal/components/Inamovilidad.vue
// module id = null
// module chunks = 